import {
  Component,
  EventEmitter,
  HostBinding,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppShellUIService } from '../../app-shell';
import { NavigationCoreComponent } from '../navigation-core.component';
import { NavigationDrawerItemInterface } from '../navigation-rail.interface';

@Component({
  standalone: false,
  selector: 'campus-navigation-drawer, [navigation-drawer]',
  templateUrl: './navigation-drawer.component.html',
  styleUrls: ['./navigation-drawer.component.scss'],
})
export class NavigationDrawerComponent extends NavigationCoreComponent implements OnInit, OnChanges {
  @Output() trigger = new EventEmitter<void>();

  public selectedItem$: BehaviorSubject<NavigationDrawerItemInterface> =
    new BehaviorSubject<NavigationDrawerItemInterface>(null);
  private appShellUIService = inject(AppShellUIService);

  @HostBinding('class')
  defaultClasses = ['cds-navigation-drawer', 'stack', 'p-b-m', 'p-ie-s', 'items-start', 'h-full'];

  @HostBinding('class.closed')
  @Input()
  closed = false;

  public isDesktop$: Observable<boolean>;
  public isHandset$: Observable<boolean>;

  public isTablet$: Observable<boolean>;

  ngOnInit() {
    this.isDesktop$ = this.appShellUIService.isDesktop$;
    this.isHandset$ = this.appShellUIService.isHandset$;
    this.isTablet$ = this.appShellUIService.isTablet$;
  }

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.items || changes.activeRouterLink) {
      const selectedItem = this.items?.find((item) => item.selected);
      this.selectedItem$.next(selectedItem);
    }
  }
}
